"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormColumnsService", {
    enumerable: true,
    get: function() {
        return FormColumnsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _models = require("~/models");
const _extractProps = require("~/helpers/extractProps");
const _ncError = require("~/helpers/ncError");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let FormColumnsService = class FormColumnsService {
    async columnUpdate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        if (context.schema_locked) {
            _ncError.NcError.get(context).schemaLocked();
        }
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/FormColumnReq', param.formViewColumn);
        const oldFormViewColumn = await _models.FormViewColumn.get(context, param.formViewColumnId, ncMeta);
        const view = await _models.View.get(context, oldFormViewColumn.fk_view_id, ncMeta);
        const column = await _models.Column.get(context, {
            colId: oldFormViewColumn.fk_column_id
        }, ncMeta);
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        const res = await _models.FormViewColumn.update(context, param.formViewColumnId, param.formViewColumn, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_COLUMN_UPDATE, {
            oldViewColumn: oldFormViewColumn,
            viewColumn: (0, _extractProps.extractProps)(param.formViewColumn, [
                'label',
                'help',
                'description',
                'required',
                'show',
                'order',
                'meta',
                'enable_scanner'
            ]),
            view,
            column,
            req: param.req,
            context
        });
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return res;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
FormColumnsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], FormColumnsService);
